module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atom-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner"
  }, [_c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-circle",
    style: (_vm.circleStyle)
  }, [_vm._v("\n      ●\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-676505f6!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/AtomSpinner.vue
// module id = 998
// module chunks = 1